<template>
  <div>
    <el-form :model="queryParams"
             ref="queryForm"
             size="small"
             :inline="true">
      <el-form-item label="App用户姓名"
                    prop="appUserName">
        <el-input v-model="queryParams.appUserName"
                  placeholder="请输入App用户姓名"
                  clearable
                  @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item label="适用App"
                    prop="appId">
        <el-select v-model="queryParams.appId"
                   placeholder="请选择适用App">
          <el-option v-for="item in appOptions"
                     :key="item.AppId"
                     :label="item.Name"
                     :value="item.AppId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题"
                    prop="title">
        <el-input v-model="queryParams.title"
                  placeholder="请输入标题"
                  clearable
                  @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   size="mini"
                   @click="handleQuery">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="userList"
              @selection-change="handleSelectionChange">
      <el-table-column type="selection"
                       width="55"
                       align="center" />
      <el-table-column label="标题"
                       prop="Title"
                       :show-overflow-tooltip="true" />
      <el-table-column label="app"
                       prop="AppName" />
      <el-table-column label="App用户姓名"
                       prop="AppUserName"
                       :show-overflow-tooltip="true" />
      <el-table-column label="开始时间"
                       prop="StartTime"
                       :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.StartTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       width="280"
                       align="center"
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="text"
                     icon="el-icon-tickets"
                     @click="handleDetail(scope.row)">会话消息</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-show="total>0"
                   :total="total"
                   :page-sizes="[2, 5, 10, 15]"
                   layout="total, sizes, prev, pager, next, jumper"
                   :page.sync="queryParams.pageIndex"
                   :limit.sync="queryParams.pageSize"
                   @pagination="handleQuery"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page.sync="currentPage1" />
  
  </div>
</template>

<script>
import { parseTime } from '@/utils/parseTime'
import { listAppInfo } from "@/api/appInfo.js";

import { ChatList } from '@/api/chatMessage'
export default {
  name:'chatMessage',
  data () {
    return {
      totalchat: 0,
      queryParamschat: {},
      userList: [],
    
      currentPage1: 1,
      total: 0,
      queryParams: {
        appId:'1001'
      },
      detailOpen: false,
      detailOpenMessage: false,
      Message: {},
      appOptions: [],
    }
  },
  mounted () {
    this.handleQuery()
    this.getAppInfo()
  },
  methods: {
    parseTime,
    async getAppInfo () {
      const [res, err] = await listAppInfo()
      this.appOptions = res.data.Data

    },
    async handleQuery () {
      const [res, err] = await ChatList({ ...this.queryParams })
      this.userList = res.data.Data
      this.total = res.data.TotalCount
    },
    async handleDetail (row) {
      this.queryParamschat = {}
      this.queryParamschat.chatId = row.Id
      this.$router.push({path:'/sys/messageList',query:{...this.queryParamschat}})
    },
    // 批量删除1
    handleSelectionChange (val) {
      this.multipleSelection = val.map((item) => item.Id);
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.handleQuery()
    },
    handleCurrentChange (val) {
      this.queryParams.pageIndex = val
      this.handleQuery()
    },
    
  }
}
</script>

<style>
.question {
  font-size: 22px;
  font-weight: 500;
}
.answer {
  margin-top: 30px;
  font-size: 16px;
}
</style>